import React from "react";
import { Box, Link } from "@commonsku/design-system";

export interface TaskClickThroughProps {
  href: string | undefined;
  children: React.ReactNode;
}

/** Wraps a task row's content in a Link to its parent record, when one is resolvable. */
const TaskClickThrough = ({ href, children }: TaskClickThroughProps) => {
  if (!href) {
    // No resolvable parent link (e.g. a JOB reminder whose project was
    // since deactivated) — render as a plain block instead of a Link with
    // no href, which would look clickable but do nothing.
    return (
      <Box display="block" flex="1" minWidth="0">
        {children}
      </Box>
    );
  }

  return (
    <Link href={href} display="block" color="inherit" flex="1" minWidth="0" _hover={{ textDecoration: "none" }}>
      {children}
    </Link>
  );
};

export default TaskClickThrough;
